/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VantageWorkflow
 */
export interface VantageWorkflow {
    /**
     * 
     * @type {string}
     * @memberof VantageWorkflow
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof VantageWorkflow
     */
    name: string;
}

export function VantageWorkflowFromJSON(json: any): VantageWorkflow {
    return VantageWorkflowFromJSONTyped(json, false);
}

export function VantageWorkflowFromJSONTyped(json: any, ignoreDiscriminator: boolean): VantageWorkflow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function VantageWorkflowToJSON(value?: VantageWorkflow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


